import { Link } from 'react-router-dom';

export default function InfluencerHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-amber-50 via-white to-rose-50">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, #d4af37 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-amber-200/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-rose-200/20 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-amber-100 to-rose-100 rounded-full mb-8 border border-amber-200/50">
          <i className="ri-vip-crown-fill text-2xl text-amber-600"></i>
          <span className="text-sm font-semibold text-gray-800 tracking-wide">PROGRAMA EXCLUSIVO</span>
        </div>

        {/* Main Title */}
        <h1 className="font-playfair text-6xl md:text-7xl lg:text-8xl font-bold text-gray-900 mb-6 leading-tight">
          Programa de Parceria
          <span className="block bg-gradient-to-r from-amber-600 via-amber-500 to-rose-500 bg-clip-text text-transparent mt-2">
            para Influencers
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto mb-8 leading-relaxed">
          Transforme vidas ao lado da <strong className="text-amber-700">Bia Holmes</strong> e ganhe acesso premium gratuito ao método que já impactou milhares de pessoas
        </p>

        {/* Stats */}
        <div className="flex flex-wrap justify-center gap-8 mb-12">
          <div className="text-center">
            <div className="text-4xl font-bold text-amber-600 font-playfair">3.247+</div>
            <div className="text-sm text-gray-600 mt-1">Vidas Transformadas</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-amber-600 font-playfair">12</div>
            <div className="text-sm text-gray-600 mt-1">Influencers Parceiras</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-amber-600 font-playfair">98%</div>
            <div className="text-sm text-gray-600 mt-1">Satisfação</div>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="#formulario"
            className="group px-10 py-5 bg-gradient-to-r from-amber-600 to-amber-500 text-white rounded-full font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <span>Quero Ser Parceira da Bia</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a 
            href="#beneficios"
            className="px-10 py-5 bg-white text-gray-800 rounded-full font-semibold text-lg hover:shadow-xl hover:scale-105 transition-all duration-300 border-2 border-gray-200 whitespace-nowrap cursor-pointer"
          >
            Ver Benefícios
          </a>
        </div>

        {/* Trust Badge */}
        <div className="mt-12 flex items-center justify-center gap-2 text-gray-600">
          <i className="ri-shield-check-line text-2xl text-amber-600"></i>
          <span className="text-sm">Parceria oficial com <strong>Bia Holmes</strong></span>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-amber-600"></i>
      </div>
    </section>
  );
}